/**
 * Hauptnavigation (Anf. 28/54).
 *
 * Sieben Einträge auf dem Handy — mehr passt nicht in eine Leiste, in der jedes
 * Ziel mindestens 48px breit ist. Kalender, Aufgaben, Dateien und Einstellungen
 * liegen unter "Mehr", nicht in einem versteckten Wischmenü (Anf. 65).
 *
 * SOS steht bewusst am Ende: dort liegt bei einhändiger Bedienung der Daumen.
 */

export const NAV_ITEMS = [
  { id: 'familie',  icon: '🏠', label: 'Familie' },
  { id: 'chat',     icon: '💬', label: 'Chat' },
  { id: 'anrufen',  icon: '📞', label: 'Anrufen' },
  { id: 'standort', icon: '📍', label: 'Standort' },
  { id: 'status',   icon: '❤️', label: "Wie geht's?" },
  { id: 'mehr',     icon: '⋯',  label: 'Mehr' },
  { id: 'sos',      icon: '🚨', label: 'SOS' },
] as const

export type RouteId = (typeof NAV_ITEMS)[number]['id']

/** Bereiche unter "Mehr" — vorhanden, aber nicht in der Hauptleiste. */
export const SECONDARY_ITEMS = [
  { id: 'suche',        icon: '🔍', label: 'Suchen' },
  { id: 'fotos',        icon: '📷', label: 'Fotos' },
  { id: 'dateien',      icon: '📁', label: 'Dateien' },
  { id: 'kalender',     icon: '📅', label: 'Kalender' },
  { id: 'aufgaben',     icon: '✅', label: 'Aufgaben' },
  { id: 'notizen',      icon: '📝', label: 'Notizen' },
  { id: 'mitglieder',   icon: '👪', label: 'Familie verwalten' },
  { id: 'einstellungen',icon: '⚙️', label: 'Einstellungen' },
] as const
